// extracted by mini-css-extract-plugin
export default {"input-wrapper":"password-field_input-wrapper__f2vkq","forgot-password":"password-field_forgot-password__6mgJ7"};